// src/components/AccountChecker/DatabaseStats.jsx
import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const DatabaseStats = ({ stats = {} }) => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  const totalAccounts = stats.totalAccounts || '60+M';
  const uniquePasswords = stats.uniquePasswords || '15M';
  const serverSources = stats.serverSources || '2,787';
  const successRate = stats.successRate || '69%';

  return (
    <section className="global-stats-section">
      <div className="section-head-line">
        <span className="section-mono-title">
          {isEn ? 'Global Infrastructure Statistics' : 'Глобальная статистика инфраструктуры'}
        </span>
      </div>

      <div className="stats-quad-grid">
        {/* Карточка 1: 60+M Извлечено данных */}
        <div className="stat-hero-card">
          <svg className="stat-backdrop-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M4 6h16M4 12h16M4 18h16" />
          </svg>
          <div className="stat-hero-card-inner">
            <div className="stat-big-number">{totalAccounts}</div>
            <div>
              <div className="stat-label-title">{isEn ? 'Data Extracted' : 'Извлечено данных'}</div>
              <div className="stat-sub-desc">
                {isEn ? 'Full leak indexing history' : 'Полная история индексации утечек'}
              </div>
            </div>
          </div>
        </div>

        {/* Карточка 2: 15M Пароли */}
        <div className="stat-hero-card">
          <svg className="stat-backdrop-icon" viewBox="0 0 24 24" fill="currentColor">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
          <div className="stat-hero-card-inner">
            <div className="stat-big-number">{uniquePasswords}</div>
            <div>
              <div className="stat-label-title">{isEn ? 'Passwords' : 'Пароли'}</div>
              <div className="stat-sub-desc">
                {isEn ? 'Hashes and decrypted credentials' : 'Хеши и расшифрованные учетные данные'}
              </div>
            </div>
          </div>
        </div>

        {/* Карточка 3: 2,787 Источников Серверов */}
        <div className="stat-hero-card">
          <svg className="stat-backdrop-icon" viewBox="0 0 24 24" fill="currentColor">
            <rect width="20" height="8" x="2" y="2" rx="2" ry="2" />
            <rect width="20" height="8" x="2" y="14" rx="2" ry="2" />
          </svg>
          <div className="stat-hero-card-inner">
            <div className="stat-big-number">{serverSources}</div>
            <div>
              <div className="stat-label-title">{isEn ? 'Server Sources' : 'Источников Серверов'}</div>
              <div className="stat-sub-desc">
                {isEn ? 'CIS and global server monitoring' : 'Мониторинг СНГ и зарубежных проектов'}
              </div>
            </div>
          </div>
        </div>

        {/* Карточка 4: 69% Процент Успеха */}
        <div className="stat-hero-card">
          <svg className="stat-backdrop-icon" viewBox="0 0 24 24" fill="currentColor">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
          </svg>
          <div className="stat-hero-card-inner">
            <div className="stat-big-number">{successRate}</div>
            <div>
              <div className="stat-label-title">{isEn ? 'Success Rate' : 'Процент Успеха'}</div>
              <div className="stat-sub-desc">
                {isEn ? 'Successful auth matching rate' : 'Успешное сопоставление авторизации'}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DatabaseStats;